import type { BigFraction } from "@aprao/common/src/math/BigFraction.js";
import { wrapFraction } from "@aprao/common/src/math/wrapFraction.js";
import { makeAutoObservable } from "mobx";

import type {
  PriceCalculationType,
  ShapePricePurchase,
} from "../shapes/ShapeSitePurchase.js";
import { WithProjectionPeriodsDelegate } from "./delegates/WithProjectionPeriodsDelegate.js";

export class PricePurchaseFacade {
  readonly $model;

  constructor(model: ShapePricePurchase) {
    makeAutoObservable(this);

    this.$model = model;
  }

  get calculationType() {
    return this.$model.calculationType;
  }

  get definedAmount() {
    return wrapFraction(this.$model.definedAmount);
  }

  get projectionPeriods() {
    return new WithProjectionPeriodsDelegate(this.$model);
  }

  set definedAmount(definedAmount: BigFraction | null) {
    this.$model.definedAmount = definedAmount?.toFraction() ?? null;
  }

  set calculationType(type: PriceCalculationType) {
    this.$model.calculationType = type;
  }
}
